import { combineEpics } from 'redux-observable';
import { listCategoriesEpic } from './list-categories';
import { searchCategoriesEpic } from './search-categories';
import { listCountriesEpic } from './list-countries';
import { loadAfterLoginEpic } from './load-after-login';

const categoriesEpic = combineEpics(
  listCategoriesEpic,
  searchCategoriesEpic,
  listCountriesEpic,
  loadAfterLoginEpic
);

export default categoriesEpic;